module.exports = __webpack_public_path__ + "static/img/bg-pt.af208618.png";